<template>
  <div class="room-interpreting-subscriber-component">
    <div class="room-interpreting-subscriber">
      <div class="interpreting subscriber">
        <div class="interpreting-header">
          <div class="interpreting-title-container">
            <p class="interpreting-title">{{ $t("interpret.lang.title") }}</p>
          </div>
          <button class="interpreting-close-button" @click="onClose"></button>
        </div>
        <div class="interpreting-body">
          <div class="interpreting-audio-control">
            <div class="interpreting-audio-control-form">
              <p class="interpreting-audio-control-title">{{ $t("interpret.left") }}</p>
              <input type="range" class="interpreting-audio-control-input">
              <p class="interpreting-audio-control-title">{{ $t("interpret.right") }}</p>
            </div>
          </div>
          <div class="interpreting-language-list-wrapper">
            <ul class="interpreting-language-list">
              <li v-for="(language, i) in languageList" :key="i" class="interpreting-language-item" :class="{ selected: subscribeLanguage === language }">
                <p class="interpreting-language-title">{{ language }}</p>
                <div class="interpreting-language-button-container">
                  <div class="interpreting-set-interpreter">
                    <button class="interpreting-set-interpreter-button subscribeInterpretingBtn" @click="onSubscribe(language)">{{ $t("interpret.subscribe.title") }}</button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="interpreting-footer">
          <button class="interpreting-change-mode-button disable" @click="onUnsubscribe">{{ $t("interpret.subscribe.cancel") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomInterpretingSubscriber',
  data() {
    return {
      languageList: [this.$t('common.ko'), this.$t('common.en')],
      subscribeLanguage: ''
    }
  },
  methods: {
    onSubscribe(language) {
      try {
        // Room.addInterpretingSubscriber(language)

        this.subscribeLanguage = language
      } catch(e) {
        console.error(e)
        this.$alert(this.$t('interpret.subscribe.fail'))
      }
    },
    onUnsubscribe() {
      try {
        // Room.removeInterpretingSubscriber(this.data.subscribeLanguage)

        this.subscribeLanguage = ''
      } catch(e) {
        console.error(e)
        this.$alert(this.$t('interpret.subscribe.cancelFail'))
      }
    },
    onClose() {
      this.$modal('RoomInterpretingModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/roomType/conf/css/_interpreting';
.room-interpreting-subscriber-component {}
.room-interpreting-subscriber {}
</style>